/**
 * Calls `onResize` once now and again after every change to the element's
 * size, and returns the function that stops observing.
 *
 * Without a ResizeObserver (jsdom, an old WebView) only the initial call happens.
 */
export function observeElementResize(element, onResize) {
    onResize();
    if (typeof ResizeObserver === 'undefined') return () => {};
    const observer = new ResizeObserver(() => onResize());
    observer.observe(element);
    return () => observer.disconnect();
}
